// lang.mjs
import langs from 'langs';

/**
 * Normalize any input (e.g. "dutch", "nl_be", "NLD", "nl-be") to canonical BCP-47.
 * Uses Intl.Locale (built-in) and falls back to 'und'.
 */
export function normalizeSrclang(input, { regionHint } = {}) {
  if (!input) return 'und';
  let code = String(input).trim().replace(/_/g, '-');

  // If it looks like a human-readable name, resolve through `langs`
  // (no hardcoded tables in your code)
  if (!/^[A-Za-z]{2,3}(-|$)/.test(code)) {
    const byName = langs.where('name', code) || langs.where('local', code);
    if (byName?.['1']) code = byName['1']; // ISO-639-1
    else if (byName?.['2']) code = byName['2']; // ISO-639-2
    else if (byName?.['2T']) code = byName['2T'];
    else if (byName?.['2B']) code = byName['2B'];
    else if (byName?.['3']) code = byName['3']; // ISO-639-3 (Intl may still accept)
  }

  try {
    let loc = new Intl.Locale(code);
    if (!loc.region && regionHint) {
      loc = new Intl.Locale(loc.baseName, {
        region: String(regionHint).toUpperCase(),
      });
    }
    return loc.baseName; // canonical (e.g. "nl-BE", "en", "fr-FR")
  } catch {
    return 'und';
  }
}

/** Human-friendly language label without hardcoding your own list */
export function labelFromLang(tag) {
  try {
    const dn = new Intl.DisplayNames(['en'], { type: 'language' });
    const lang = new Intl.Locale(tag).baseName; // distinguish regional subtitle tracks
    return dn.of(lang) || (tag || 'Subtitles').toUpperCase();
  } catch {
    return (tag || 'Subtitles').toUpperCase();
  }
}
